import { render } from "./DynamicFormButton.vue?vue&type=template&id=606995e6&ts=true"
import script from "./DynamicFormButton.vue?vue&type=script&lang=ts"
export * from "./DynamicFormButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__